import React from 'react';
import { SectionHeader } from '../../components';

const FAQSection = () => {
  const faqs = [
    {
      question: 'What services does GrowthVibe offer?',
      answer: 'We offer comprehensive digital marketing and IT solutions including SEO, PPC, social media marketing, web development, and more.'
    },
    {
      question: 'How long does it take to see results?',
      answer: 'Results vary by service and industry, but most clients see initial improvements within 30-60 days.'
    },
    {
      question: 'Do you work with small businesses?',
      answer: 'Yes! We work with businesses of all sizes, from startups to enterprise-level companies.'
    },
    {
      question: 'What is your pricing structure?',
      answer: 'Our pricing is customized based on your specific needs and goals. Contact us for a personalized quote.'
    }
  ];

  return (
    <section className="section-padding">
      <div className="container">
        <SectionHeader
          subtitle="FAQ"
          title="Frequently Asked Questions"
          description="Find answers to common questions about our services"
        />
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="accordion" id="faqAccordion">
              {faqs.map((faq, index) => (
                <div key={index} className="accordion-item">
                  <h2 className="accordion-header" id={`faq-${index}`}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#faq-collapse-${index}`}
                      aria-expanded="false"
                      aria-controls={`faq-collapse-${index}`}
                    >
                      {faq.question}
                    </button>
                  </h2>
                  <div
                    id={`faq-collapse-${index}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`faq-${index}`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      {faq.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
